import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  computed: _objectSpread({}, mapGetters(['webInfo']))
};